import React from 'react';
import { message } from 'antd';
import { CFT160, CFT164, t20aApi } from '../../../services/t20aApi';

interface Tab2Props {
  formData: Partial<CFT160>;
  customerPeople: Partial<CFT164>[];
  isEditing: boolean;
  addCustomerRow: () => void;
  deleteCustomerRow: (idx: number) => void;
  setCustomerField: (idx: number, key: keyof CFT164, value: CFT164[keyof CFT164]) => void;
  selectedCustomerIdx: number;
  setSelectedCustomerIdx: (idx: number) => void;
}

/** Tab 2: Customer Attendees (Page2 from ui_spec - CFT164) */
const Tab2CustomerPeople: React.FC<Tab2Props> = React.memo(({
  formData, customerPeople, isEditing,
  addCustomerRow, deleteCustomerRow, setCustomerField,
  selectedCustomerIdx, setSelectedCustomerIdx,
}) => (
  <div>
    <div className="form-grid" style={{ marginBottom: 12 }}>
      <label>客戶參加人數</label>
      <input
        type="number"
        value={formData.ft160_25 ?? 0}
        readOnly
        style={{ width: 80 }}
      />
    </div>

    <div className="table-wrapper">
      <div className="table-toolbar">
        <div className="left">
          <span style={{ fontWeight: 500, fontSize: 13 }}>客戶參加人員</span>
        </div>
        <div className="right">
          <button className="btn btn-sm" disabled={!isEditing} onClick={addCustomerRow}>明細新增</button>
          <button className="btn btn-sm btn-danger" disabled={!isEditing || customerPeople.length === 0}
            onClick={() => deleteCustomerRow(selectedCustomerIdx)}>明細刪除</button>
        </div>
      </div>
      <div className="table-scroll" style={{ maxHeight: 340 }}>
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 56 }}>序號</th>
              <th style={{ width: 93 }}>姓名</th>
              <th style={{ width: 99 }}>職稱</th>
              <th style={{ width: 186 }}>部門</th>
              <th style={{ width: 112 }}>客戶簡稱</th>
              <th style={{ width: 200 }}>客戶名稱</th>
              <th style={{ width: 70 }}>制式化問題</th>
              <th style={{ width: 80 }}>Meeting Record</th>
            </tr>
          </thead>
          <tbody>
            {customerPeople.map((row, idx) => (
              <tr
                key={idx}
                className={idx === selectedCustomerIdx ? 'selected' : ''}
                onClick={() => setSelectedCustomerIdx(idx)}
              >
                <td>{row.ft164_02}</td>
                <td>
                  <input
                    type="text"
                    value={row.ft164_10 || ''}
                    onChange={e => setCustomerField(idx, 'ft164_10', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft164_11 || ''}
                    onChange={e => setCustomerField(idx, 'ft164_11', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft164_12 || ''}
                    onChange={e => setCustomerField(idx, 'ft164_12', e.target.value)}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={row.ft164_13 || ''}
                    onChange={e => setCustomerField(idx, 'ft164_13', e.target.value)}
                    onBlur={async () => {
                      const code = row.ft164_13 || '';
                      if (!code) return;
                      const name = await t20aApi.lookupName('customer', code);
                      setCustomerField(idx, 'ft164_14', name);
                    }}
                    disabled={!isEditing}
                    style={{ width: '100%', height: 28, fontSize: 13 }}
                  />
                </td>
                <td>{row.ft164_14 || ''}</td>
                <td style={{ textAlign: 'center' }}>
                  <button
                    className="btn btn-sm"
                    disabled={!row.ft164_13}
                    onClick={() => {
                      if (!row.ft164_13) {
                        message.warning('客戶名稱不可空白!');
                        return;
                      }
                      message.info('制式化問題功能開發中');
                    }}
                  >
                    問題
                  </button>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <button
                    className="btn btn-sm"
                    disabled={!row.ft164_13}
                    onClick={() => {
                      if (!row.ft164_13) {
                        message.warning('客戶名稱不可空白!');
                        return;
                      }
                      message.info('Meeting Record 功能開發中');
                    }}
                  >
                    Record
                  </button>
                </td>
              </tr>
            ))}
            {customerPeople.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: 'center', color: 'rgba(0,0,0,0.25)' }}>無資料</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
));

Tab2CustomerPeople.displayName = 'Tab2CustomerPeople';
export default Tab2CustomerPeople;
